import { createContext } from 'react';

export type AlgonomyContextState = {
  isLoading: boolean;
  openFilter: boolean;
  mobile: boolean;
  setIsLoading: (loading: boolean) => void;
  handleSelectFilter: (facet: string, filterValue: string, filterName: string, val: boolean) => void;
  handleChangeTab: (tab: string) => void;
  setOpenFilter: (loading: boolean) => void;
  handleSort: (sortValue: string) => void;
  handleOnClickOutside: () => void;
  handleApplyFilters: () => void;
};

const AlgonomyContext = createContext<AlgonomyContextState | undefined>(undefined);

export default AlgonomyContext;
